/* @flow weak */

'use strict';

const React = require('react');
const _ = require('lodash');
const ControlMixin = require('../../mixins/ControlMixin.jsx');

const Config = require('../../configs/Config.js');

const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const InputRadio = React.createClass({
  mixins: [ControlMixin],

  render() {
    let controls = _.map(this.props.parts, part => {
      let inputID = `uc-c-${this.props.question.id}-${part.id}`;

      let price = this.getPrice(part);
      const partDetails = this.getPartDetails(part);
      let priceHtml = null;

      let s3url = Config.images.s3url;
      let hasImage = !!_.get(part, 'metadata.StaticImage');
      let partImage = hasImage ? <img alt={this.displayPartName(part)} src={s3url + _.get(part, 'metadata.StaticImage')} /> : null;

      let activeClass = this.state.answer === part.id ? ' uc-active' : '';
      let priceClass = price ? ' uc-has-price' : '';
      let imageClass = hasImage ? ' uc-has-image' : '';
      let labelClass = 'uc-radio-button' + activeClass + priceClass + imageClass;
      let partQuickturnMessaging = _.get(part, 'metadata.PartQuickturnMessaging');
      let quickturnMessagingHtml = partQuickturnMessaging ? <span className="uc-part-quickturn-messaging">{partQuickturnMessaging}</span> : null;
      const hidePartNameClass = this.isPartNamesHidden(this.props.question) ? ' uc-hide-part-name' : '';
      var forcePriceHiding = _.get(this.props.question, 'metadata.ForcePriceHiding');

      switch (_.get(price, 'type')) {
        case 'simple':
          if (parseFloat(price.retail_price) < parseFloat(price.full_price)) {
            priceHtml = (
              <div className='uc-part-price-container'>
                <div className='uc-part-price-sale'>
                  <span>{price.is_upcharge ? '+' : null}{this.currency}{price.retail_price}</span>
                  {Config.features.displayPartSaleLabel ? <span className='uc-sale-label'> Sale</span> : null}
                </div>
                <div className='uc-part-price-was'>was <span className='uc-part-price-strikethrough'>{this.currency}{price.full_price}</span></div>
              </div>
            );
          } else {
            priceHtml = (
              <div className='uc-part-price-container'>{price.is_upcharge ? '+' : null}{this.currency}{price.retail_price}</div>
              );
          }

          break;
        case 'startingAt':
          if (parseFloat(price.retail_price) < parseFloat(price.full_price)) {
            priceHtml = (
              <div className='uc-part-price-container'>
                <div className='uc-part-price-sale'>
                <span className="starting-at-prefix">{Config.features.startingAtText[ln]} </span><span>{this.currency}{price.retail_price}</span>
                  {Config.features.displayPartSaleLabel ? <span className='uc-sale-label'> Sale</span> : null}
                </div>
                <div className='uc-part-price-was'>was <span className='uc-part-price-strikethrough'>{this.currency}{price.full_price}</span></div>
              </div>
            );
          } else {
            priceHtml = (
              <div className='uc-part-price-container'>
                <div><span className="starting-at-prefix">{Config.features.startingAtText[ln]} </span> {this.currency}{price.retail_price}</div>
              </div>
            );
          }

          break;
      }

      return (
        <label
          className={labelClass}
          key={part.id}
          role='radio' 
          htmlFor={inputID}>

          <input
            id={inputID}
            className='uc-c uc-c-inputradio'
            type='radio'
            name={this.props.question.name}
            onChange={this.handleChange}
            checked={this.state.answer === part.id}
            value={part.id}
            tabIndex={this.props.tabIndex}
            disabled={this.state.locked} />
          <span> </span>

          <div className='uc-part-info'>
            <div className={'uc-part-name' + hidePartNameClass}>
              {this.displayPartName(part)}
            </div>
            {priceHtml}
            {partDetails ?
              <p className="uc-part-details" dangerouslySetInnerHTML={{__html: partDetails}}></p>
              : null}
          </div>

          {partImage}  
          {quickturnMessagingHtml}
        </label>
      );
    });

    return (
      <div className={`uc-control uc-radio-group${this.state.locked ? ' uc-locked' : ''}`}>
        {controls}
      </div>
    );
  }
});

module.exports = InputRadio;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/InputRadio.jsx